(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-card"] && !Shopify.designMode) return;
  try {
    // Dog Dad blog card click target
  document.addEventListener('click', (event) => {
    const card = event.target.closest('.blog-post-card[data-article-url]');

    if (!card || event.target.closest('a, button, input, select, textarea')) {
      return;
    }

    window.location.href = card.dataset.articleUrl;
  });
  } catch(e) { console.error(e); }
})();

})();
